import { FC, ReactNode } from 'react';
import {
  EvaluationResultSpecific,
  Metric,
} from '@agilelab/plugin-wb-governance-common';
import { GovernanceTestOverviewMetricControlPanel } from './GovernanceTestOverviewMetricControlPanel';
import { GovernanceTestOverviewMetricSimple } from './GovernanceTestOverviewMetricSimple';
import { GovernanceTestOverviewMetricTabs } from './GovernanceTestOverviewMetricTabs';

interface CommonProps {
  children?: ReactNode;
}

type ConditionalProps =
  | {
      kind: 'simple';
      metric: Metric;
    }
  | {
      kind: 'tabs';
      result: EvaluationResultSpecific;
      metric: Metric;
    }
  | {
      kind: 'controlPanel';
      infoContent?: JSX.Element;
      metric: Metric;
      test: {
        errors?: string[];
        content: string;
        name: string;
      };
    };

type Props = CommonProps & ConditionalProps;

export const GovernanceTestOverviewMetric: FC<Props> = props => {
  switch (props.kind) {
    case 'simple':
      return <GovernanceTestOverviewMetricSimple {...props} />;
    case 'tabs':
      return <GovernanceTestOverviewMetricTabs {...props} />;
    case 'controlPanel':
      return <GovernanceTestOverviewMetricControlPanel {...props} />;
    default:
      return <></>;
  }
};
